import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home/Home";
import About from './Pages/About/About'
import Layout from "./components/Layout"; 
import Services from "./Pages/Services/Services";
import Projects from "./Pages/Projects/Projects";
import CompanyCulture from "./Pages/CompanyCulture/CompanyCulture";
import ContactUs from "./Pages/Contactus/Contactus";

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/companyCulture" element={<CompanyCulture />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
